import { createFileRoute } from "@tanstack/react-router";
import { m } from "~/lib/i18n";

/**
 * Solana Multiply proof of concept (GLI-1918). Reachable by URL only and
 * gated in the page by the `solana_multiply_poc` flag; signed-out and
 * un-flagged visitors get the not-found page.
 */
export const Route = createFileRoute("/_app/solana-multiply")({
  head: () => ({
    meta: [
      { title: m.solana_multiply_page_meta_title() },
      {
        content: m.solana_multiply_page_meta_description(),
        name: "description",
      },
      { content: "noindex, nofollow", name: "robots" },
    ],
  }),
});
